// export { default as Application } from './Application';
// export { default as ApplicationNew } from './Application'
// export { default as ClientHome } from './ClientHome'
// export { ClientFinancingProfile } from './ClientFinancingProfile'

import React from 'react'
import { withLazyRoute } from '@/components/Lazy/LazyRouteWrapper'

export const ClientHome = withLazyRoute(
  React.lazy(() => import('./ClientHome')),
  'Loading client home...',
)

export const ClientFinancingProfile = withLazyRoute(
  React.lazy(() => import('./ClientFinancingProfile')),
  'Loading client financing profile...',
)

export const ApplicationNew = withLazyRoute(
  React.lazy(() => import('./Application')),
  'Loading application new...',
)
